import { api } from "shared/redux/api"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTeacherLeaveByLXO: build.query({
      query: (params) => {
        const searchParams = new URLSearchParams(params)

        return {
          url: `/private/teacher/v1/history?${searchParams.toString()}`,
        }
      },
    }),
    getViewTeacherLeaveByLXO: build.query({
      query: (params) => {
        const { id, ...rest } = params
        const searchParams = new URLSearchParams(rest)
        return {
          url: `/private/teacher/v1/history/${id}?${searchParams.toString()}`,
        }
      },
    }),
    getTimeSheetLXO: build.query({
      query: (params) => {
        const { id, ...rest } = params
        const searchParams = new URLSearchParams(rest)
        return {
          url: `/private/teacher/v1/teaching-hour?${searchParams.toString()}`,
        }
      },
    }),
    getTimeSheetLXODetail: build.query({
      query: (params) => {
        const { id, ...rest } = params
        const searchParams = new URLSearchParams(rest)
        return {
          url: `/private/teacher/v1/teaching-detail?teacherId=${id}&${searchParams.toString()}`,
        }
      },
    }),
    markDone: build.mutation({
      query: (params) => {
        const { id, ...rest } = params
        return {
          url: `/private/general-task/v1/${id}/mark-done`,
          method: "POST",
          body: rest,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useLazyGetTeacherLeaveByLXOQuery,
  useLazyGetViewTeacherLeaveByLXOQuery,
  useLazyGetTimeSheetLXOQuery,
  useLazyGetTimeSheetLXODetailQuery,
  useMarkDoneMutation,
} = injectedRtkApi
